export default __webpack_public_path__ + "static/media/water.f30bf5d3.png";